export const getSx = (collapse) => {
  return {
    headerContainer: {
      marginBottom: "1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    notificationIcon: {
      cursor: "pointer",
    },
    sidebarContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      borderRadius: collapse ? "20px" : "40px",
      backgroundColor: "#231F20",
      height: "100%",
      padding: "30px 0",
      zIndex: 9,
      boxSizing: "border-box",
    },
    sidebarItems: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      padding: collapse ? "0 10px" : "0 45px",
    },
    smallLogo: {
      aspectRatio: "1.46",
      objectFit: "contain",
      objectPosition: "center",
      width: "42px",
      height: "56px",
      overflow: "hidden",
      maxWidth: "100%",
    },
    bigLogo: {
      width: "124px",
      height: "auto",
    },
    arrowLeftCircle: {
      cursor: "pointer",
      position: "absolute",
      bottom: "-85px",
      right: "-42px",
    },
    itemList: {
      width: "100%",
      paddingTop: "60px",
      paddingBottom: "30px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "344px",
      overflow: "auto",
    },
    sidebarItemContainer: {
      display: "flex",
      position: "relative",
      alignItems: "center",
      cursor: "pointer",
      padding: {
        xs: "15px 30px",
        sm: collapse ? "15px 28px" : "15px 10px",
        lg: "15px 30px",
      },
      fontWeight: 500,
    },
    sidebarItem: {
      backgroundColor: "white",
      width: "6px",
      height: "24px",
      borderRadius: "0 4px 4px 0",
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
    },
    imageContainer: {
      width: "24px",
      height: "24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    sidebarLabel: {
      color: "white",
      fontSize: "16px",
      fontWeight: 400,
      my: "auto",
      paddingLeft: "15px",
      filter: "revert(-1)",
    },
    logoutContainer: {
      display: "flex",
      position: "absolute",
      bottom: "2rem",
      alignItems: "center",
      cursor: "pointer",
      padding: {
        xs: "15px 30px",
        sm: collapse ? "15px 28px" : "15px",
        lg: "15px 30px",
      },
      fontWeight: 500,
      marginBottom: "15px",
    },
    logoutIcon: {
      backgroundColor: "white",
      width: "6px",
      height: "24px",
      borderRadius: "0 4px 4px 0",
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      opacity: 0,
    },
    logoutText: {
      color: "white",
      fontSize: "16px",
      fontWeight: 500,
      my: "auto",
      paddingLeft: "15px",
    },
  };
};
